import { DOCUMENT } from '@angular/common';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

const ALLOWED = ['es', 'en', 'fr', 'pt', 'it'];

/**
 * Envía Accept-Language al API del journey para localizar validaciones Laravel.
 * No inyecta LanguageService (evita ciclo con TranslateService / HttpClient).
 * Usa `document.documentElement.lang` (lo actualiza LanguageService).
 */
@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
	private readonly document = inject(DOCUMENT);

	public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		if (!this.shouldAttach(req.url)) {
			return next.handle(req);
		}

		return next.handle(
			req.clone({
				setHeaders: {
					'Accept-Language': this.resolveAcceptLanguage(),
				},
			}),
		);
	}

	private shouldAttach(url: string): boolean {
		const apiBase = environment.identity2;
		return Boolean(apiBase && url.includes(apiBase));
	}

	private resolveAcceptLanguage(): string {
		const fromDoc = (this.document.documentElement?.lang ?? '').toLowerCase().split('-')[0];
		if (fromDoc && ALLOWED.includes(fromDoc)) {
			return fromDoc;
		}
		return 'es';
	}
}
